import { render, staticRenderFns } from "./hainanCourseList.vue?vue&type=template&id=5c9038de"
import script from "./hainanCourseList.vue?vue&type=script&lang=js"
export * from "./hainanCourseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports